import { ArrowRight, BookOpen } from 'lucide-react'
import { Link } from 'react-router-dom'

import { useMackinacTabPrefs } from '@/hooks/useMackinacTabPrefs'
import { parseStandardDocumentUri } from '@/lib/standardSite'
import { strings } from '@/strings'
import type { PostEmbed } from '@/types/posts'

interface StandardSiteReadInAppCTAProps {
    embed: PostEmbed
}

export function StandardSiteReadInAppCTA({ embed }: StandardSiteReadInAppCTAProps) {
    const { openArticlesExternally } = useMackinacTabPrefs()

    if (embed.type !== 'external') return null

    const docRef = parseStandardDocumentUri(embed.associatedRefs)

    if (!docRef) return null

    if (openArticlesExternally) return null

    return (
        <div className="my-4 flex items-center gap-3">
            <Link
                to={`/profile/${docRef.did}/article/${docRef.rkey}`}
                onClick={e => e.stopPropagation()}
                className="inline-flex items-center gap-1.5 text-xs font-medium text-primary hover:underline"
            >
                <BookOpen className="w-3.5 h-3.5" aria-hidden="true" />
                <span>{strings.articles.readInMackinac}</span>
                <ArrowRight className="w-3.5 h-3.5" aria-hidden="true" />
            </Link>
        </div>
    )
}
